<div class="stats-empty">
  <div class="stats-empty__icon-wrap">
    <mat-icon class="stats-empty__icon">bar_chart</mat-icon>
  </div>
  <p class="stats-empty__title">{{ 'Stats_empty_title' | translate }}</p>
  <p class="stats-empty__subtitle">{{ 'Stats_empty_subtitle' | translate }}</p>
</div>
